var myLazyLoad = new LazyLoad({
    elements_selector: ".lazy"
});
jQuery(function ($) {
    $('.ramka-modal').on('click', function (e) {
        $.arcticmodal('close');
        $('#ramka-modal').arcticmodal({
            type: 'ajax',
            async: true,
            url: $(this).attr('href'),
            ajax: {
                type: 'GET',
                cache: false,
                // dataType: 'json',
                data: 'modal=true',
                success: function (data, el, response) {
                    var h = $('<div class="box-modal">' +
                        '<div class="box-modal_close arcticmodal-close">X</div>' +
                        '<div id="ramka-editor">' +
                        '</div>');
                    $('#ramka-editor', h).html(response);
                    data.body.html(h);
                }
            }
        });
        return false;
    });
    /**
     *
     */
        //Validate register form
    let form_register_rules = {
            focusCleanup: true,
            errorElement: 'div',
            errorClass: 'alert alert-error',
            highlight: function (element, errorClass) {
                $(element).parent().addClass('error');
            }, unhighlight: function (element, errorClass) {
                $(element).parent().removeClass('error');
            },
            rules: {
                name: "required",
                email: {
                    required: true,
                    email: true
                },
                password: {
                    required: true,
                    minlength: 5
                },
                password_confirmation: {
                    required: true,
                    // equalTo: ".password"
                },
            },
            messages: {
                required: 'Заполните это поле.',
                name: {
                    required: "Пожалуйста, введите Имя.",
                    minlength: "Имя должны быть больше 6 символов.",
                    maxlength: "Имя должны быть меньше 16 символов."
                },
                email: "Введите правильный email.",
                password: {
                    required: "Введите пароль.",
                    minlength: "Пароль должен состоять минимум из 5 символов.",
                    maxlength: "Имя должны быть меньше 16 символов."
                },
                password_confirmation: {
                    required: "Введите потверждение пароля.",
                    equalTo: "Пароли не совпадают."
                },
            }
        };
    $(".form_register").validate(form_register_rules);


    /**
     * Кнопки входа и регистрации
     */
    $(document).on("click", ".mdl-login-button", function (e) {
        $.arcticmodal('close');
        // $('#login-forma').arcticmodal();
        $.arcticmodal({
            type: 'ajax',
            url: $(this).data('url'),
            ajax: {
                type: 'GET',
                cache: true,
                dataType: 'json',
                success: function (arctic, el, data) {
                    // console.log(data);
                    if (data.result === 'ok') {
                        console.log(data.login_menu);
                        if (data.login_menu !== false) {
                            $('#navbar_login').html(data.login_menu);
                            $('#navbar_cart').html(data.cart_menu);
                            $.arcticmodal('close');
                            $('.no-auth-user').hide();
                        } else {
                            var h = $('<div class="box-modal">' +
                                '<div class="box-modal_close arcticmodal-close">X</div>' +
                                '<p><b /></p><p />' +
                                '</div>');
                            $('P:last', h).html(data.login_form);
                            arctic.body.html(h);
                            // $(".box-modal .form_register").validate(form_register_rules);
                        }
                    }
                }
            }
        });
        return false;
    });
//Открытие модального окна с формой регистрации
    $(document).on("click", ".mdl-register-button", function (e) {
        e.preventDefault();
        $.arcticmodal('close');
        $.arcticmodal({
            type: 'ajax',
            url: $(this).data('url'),
            ajax: {
                type: 'GET',
                cache: true,
                dataType: 'json',
                success: function (arctic, el, data) {
                    console.log(data);
                    if (data.result === 'ok') {
                        console.log(data.login_menu);
                        if (data.login_menu !== false) {
                            $('#navbar_login').html(data.login_menu);
                            $('#navbar_cart').html(data.cart_menu);
                            $.arcticmodal('close');
                            $('.no-auth-user').hide();

                        } else {
                            var h = $('<div class="box-modal">' +
                                '<div class="box-modal_close arcticmodal-close">X</div>' +
                                '<p><b /></p><p />' +
                                '</div>');
                            $('P:last', h).html(data.register_form);
                            arctic.body.html(h);
                            $(".box-modal .form_register").validate(form_register_rules);
                        }
                    }
                }
            }
        });
        return false;
    });

    $(document).on('submit', '.form-login', function () {
        let $this = $(this);

        if ($this.attr('data-ok') === 'true') {
            if (window.location.pathname === '/register') {
                window.location = '/';
            } else
                window.location = window.location;

            return false;
        }
        $.ajax({
            context: $this,
            data: $this.serialize(),
            traditional: true,

            type: "POST",
            url: $this.attr('action'),
            dataType: 'json',
            cache: false,
            timeout: 30000,
            error: function (jqXHR, textStatus, errorThrown) {
                $this.find('.alert').html('Ошибка сервера. Перезагрузите страницу.').show();
            },
            success: function (data, textStatus, jqXHR) {
                if (data.result === 'ok') {
                    $this.attr('data-ok', 'true');
                    if(data.login_menu !== false){
                        $('#navbar_login').html(data.login_menu);
                        $('#navbar_cart').html(data.cart_menu);
                        $('.ajax-data-user_name').html(data.user_name);
                        $('.ajax-data-user_id').data('user_id',data.user_id);
                        $.arcticmodal('close');
                        $('.no-auth-user').hide();
                        $('.if-auth-user').show();
                    }
                    else if(data.http_referer !== false){
                        window.location = data.http_referer;
                    } else {
                        $this.attr('action', "/").submit();
                    }
                } else {
                    $this.find('.alert').html(data.msg).show();
                }
            }
        });
        return false;
    });

//Клик по форме регистрации в модальном окне ()
    $(document).on('submit', '.box-modal .form_register', function (e) {
        e.preventDefault();

        let btn = $(this).closest('form').find(':submit');
        btn.prop('disabled',true);

        let $this = $(this);
        let $alert = $this.find('.alert-all');

        $.ajax({
            context: $this,
            data: $this.serialize(),
            traditional: true,
            type: "POST",
            url: $this.data('action'),
            dataType: 'json',
            cache: false,
            timeout: 60000,
            before: function(){
              $('.ajax.alert').remove();
                $alert.html('')
            },
            error: function (json) {
                if (json.status === 422) {
                    $alert.html('Ошибка').show();
                    console.log(json.responseJSON);
                    $.each(json.responseJSON.errors, function (i, error) {
                        let el = $(document).find('[name="'+i+'"]');
                        el.after($('<span class="ajax alert">'+error[0]+'</span>'));
                    });
                } else {
                    console.log(json);
                    $alert.html('Ошибка сервера. Перезагрузите страницу.').show();

                }
                btn.prop('disabled',false);
            },
            success: function (data, textStatus, jqXHR) {
                console.log(data);
                if (data.result == 'ok') {
                    if(data.login_menu !== false){
                        $('#navbar_login').html(data.login_menu);
                        $('#navbar_cart').html(data.cart_menu);
                        $.arcticmodal('close');
                        $('.no-auth-user').hide();
                    }
                    else if (window.location.pathname === '/register') {
                        window.location = '/';
                    } else {
                        window.location = window.location;
                    }
                } else {
                    $alert.html(data.msg).show();
                }
                btn.prop('disabled',false);
            }
        });

        return false;
    });

    $(document).on('click', '.ajax-link', function (e) {
        e.preventDefault();
        let $this = $(this);
        // let $alert = $this.find('.alert-all');

        $.ajax({
            context: $this,
            traditional: true,
            type: $this.data('method'),
            url: $this.data('href'),
            dataType: 'json',
            cache: false,
            timeout: 30000,
            before: function(){
                // $('.ajax.alert').remove();
                // $alert.html('')
            },
            error: function (json) {
                if (json.status === 422) {
                    // $alert.html('Ошибка').show();
                    // console.log(json.responseJSON);
                    $.each(json.responseJSON.errors, function (i, error) {
                        // $alert.after($('<span class="ajax alert">'+error[0]+'</span>'));
                        noty(error[0]);
                    });
                } else {
                    noty('Ошибка сервера. Перезагрузите страницу.');
                    // $alert.html('Ошибка сервера').show();

                }
            },
            success: function (data, textStatus, jqXHR) {
                noty(data.msg);
            }
        });
        return false;
    });

    $(document).ready(function () {
        $('.tooltip').tooltipster();

        $('.menuFotoNored').tooltipster({
            content: '.',
            functionBefore: function (origin, continueTooltip) {
                continueTooltip();
                origin.tooltipster('content', origin.data('tooltip'));
            },
            trigger: 'click',
            position: 'top',
            theme: 'tooltipster-shadow',
            contentAsHTML: true
        });


        // $('.register-button').on('click', function (e) {
        //     console.log('register-button');
        //     $.arcticmodal('close');
        //     $.arcticmodal({
        //         type: 'ajax',
        //         url: '/register_ajax',
        //         ajax: {
        //             type: 'GET',
        //             success: function (data, el, responce) {
        //                 var h = $('<div class="box-modal login" id="register-forma">' + '<div class="box-modal_close arcticmodal-close"></div>' + responce + '</div>');
        //                 data.body.html(h);
        //             }
        //         }
        //     });
        //     return false;
        // });
        $('.img-modal').on('click', function (e) {
            var c = $('<div class="box-modal2" />');
            c.prepend('<div class="box-modal_close arcticmodal-close"></div>'
                + '<div style="text-align: center;"><img src="' + $(this).attr('href') + '"></div>'
//                    + '<div class="box-modal_title">' + $(this).attr('title') + '"</div>'

            );
            $.arcticmodal({
                content: c,
            });

            return false;
        });

    });

//     // Create variables (in this scope) to hold the API and image size
//     var jcrop_api,
//         boundx,
//         boundy,
//         // Grab some information about the preview pane
//         $preview = $('#preview-pane'),
//         $pcnt = $('#preview-pane .preview-container'),
//         $pimg = $('#preview-pane .preview-container img'),
//         xsize = $pcnt.width(),
//         ysize = $pcnt.height();
//
// //    console.log('init', [xsize, ysize]);
//     $('#target').Jcrop({
//         onChange: updatePreview,
//         onSelect: updatePreview,
//         onSelect: updateCoords,
//         setSelect: [150, 150, 50, 50],
//         aspectRatio: xsize / ysize
//     }, function () {
//         // Use the API to get the real image size
//         var bounds = this.getBounds();
//         boundx = bounds[0];
//         boundy = bounds[1];
//         // Store the API in the jcrop_api variable
//         jcrop_api = this;
//
//         // Move the preview into the jcrop container for css positioning
//         $preview.appendTo(jcrop_api.ui.holder);
//     });
//
//
//     function updatePreview(c) {
//         if (parseInt(c.w) > 0) {
//             var rx = xsize / c.w;
//             var ry = ysize / c.h;
//
//             $pimg.css({
//                 width: Math.round(rx * boundx) + 'px',
//                 height: Math.round(ry * boundy) + 'px',
//                 marginLeft: '-' + Math.round(rx * c.x) + 'px',
//                 marginTop: '-' + Math.round(ry * c.y) + 'px'
//             });
//         }
//     }
//     ;
});

function updateCoords(c) {
    $('#x').val(c.x);
    $('#y').val(c.y);
    $('#w').val(c.w);
    $('#h').val(c.h);
}
;

function checkCoords() {
    if (parseInt($('#w').val()))
        return true;
    alert('Выбирите нужную область перед отправкой.');
    return false;
}
;

function add_photo(pos) {
    var c = $('<div class="box-modal" />');
    c.html($('.b-text').html('привет'));
    c.prepend('<div class="box-modal_close arcticmodal-close"></div>'
        + '<div style="text-align: center;"><form action="" method="post" accept-charset="utf-8" enctype="multipart/form-data">'
        + '<h3>Загрузить фотографию:</h3><br>'
        + '<h4>Внимание!</h4>'
        + '<h5>Качественные работы получаются с хороших фотографий больших размеров.</h5><br>'
        + '<h5>Выбрать фото с компьютера:</h5>'
        + '<input type="hidden" name="position" value="' + pos + '" />'
        + '<input type="file" name="photo_file"  style="text-align: center;"/><br><br>'
        //============================================================================
        //+'<input type="file" name="photo_test"  style="text-align: center;"/><br><br>'
        //============================================================================
        + '<h5 style="text-align: center;">Или загрузить с адреса:</h5>'
        + '<input type="text" name="photo_url" value="http://" size="40" />'
        + '<br><br><input type="submit" name="add" value=" Загрузить " />'
        + '</form></div><br>'
    );
    $.arcticmodal({
        content: c
    });
}

function add_photo_albom(pos, dom, mass) {

    var pics = explode(',', mass);
    var text = '<table><tr>';
    for (var i = 0; i < pics.length; i++) {
        if (i % 3 == 0) {
            text += '</tr><tr>';
        }
        text += '<td><form action="" method="post" name="f_' + i + '" accept-charset="utf-8"><input type="hidden" name="position" value="' + pos + '" /><input type="hidden" name="photo_url" value="//' + dom + '/media/images/user_albom/' + pics[i] + '" /><img src="/media/images/user_albom_prew/' + pics[i] + '" alt="' + pics[i] + '" class="prew_alb" onclick="javascript:document.f_' + i + '.submit(); return false;"></form></td>';
    }
    text += '</tr>';
    var c = $('<div class="box-modal" />');
    c.html($('.b-text').html('привет'));
    c.prepend('<div class="box-modal_close arcticmodal-close"></div>'
        + '<div style="text-align: center;">'
        + '<h3>Загрузить фотографию с альбома:</h3><br>'
        + text
        + '</div><br>'
    );
    $.arcticmodal({
        content: c
    });


}

function red_y() {
    var but_val = document.getElementById('no_red');
    but_val.setAttribute("value", 'no_red_eee');
}

function red_n() {
    var but_val = document.getElementById('no_red');
    but_val.setAttribute("value", '');
}

function help_click(id) {
    var help_win = document.getElementById('left_float');
    help_win.setAttribute("style", 'display:block;');
    var red_but = document.getElementById(id);
    red_but.setAttribute("onclick", 'javascript:document.add_cur_crop.submit(); return false;');
    red_but.setAttribute("OnMouseOver", 'red_y();');
    red_but.setAttribute("OnMouseOut", 'red_n();');
    $('div.jcrop-tracker').attr("onclick", "info_click();");
}

function info_click() {
    var info_win = document.getElementById('panel_info');
    info_win.setAttribute("style", 'display:block;');
    $('div.jcrop-tracker').removeAttr("onclick");
    var help_win = document.getElementById('left_float');
    help_win.setAttribute("style", 'display:none;');
}


function setValidator(id, regex) {
    var element = document.getElementById(id);
    if (element) {
        var lastValue = element.value;
        if (!regex.test(lastValue))
            lastValue = '';
        setInterval(function () {
            var value = element.value;
            if (value != lastValue) {
                if (regex.test(value))
                    lastValue = value;
                else
                    element.value = lastValue;
            }
        }, 10);
    }
}

function add2Fav(x) {
    if (document.all && !window.opera) {
        if (typeof window.external == "object") {
            window.external.AddFavorite(document.location, document.title);
            return true;
        } else
            return false;

    } else {
        x.href = document.location;
        x.title = document.title;
        x.rel = "sidebar";
        return true;
    }
}

function focus_cur_div(id) {
    var $targetDiv = $("#add_" + id);
    if ($targetDiv) {
        var ele = document.getElementById("add_" + id);
        window.scrollTo(ele.offsetLeft, ele.offsetTop);
//        var $window = $(window);
//        $window.scrollTop($targetDiv.offset().top);
    }
}


$().ready(function () {
    // validate signup form on keyup and submit


    $("#profile").validate({
        errorElement: 'span',
        errorClass: 'help-block',
        highlight: function (element, errorClass) {
            $(element).parent().parent().addClass('error');
        }, unhighlight: function (element, errorClass) {
            $(element).parent().parent().removeClass('error');
        },
        rules: {
            fi_name: "required",
            la_name: "required",
            email: {
                required: true,
                email: true
            },
        },
        messages: {
            required: 'Заполните это поле.',
            la_name: "Пожалуйста, введите Фамилию",
            fi_name: {
                required: "Пожалуйста, введите Имя",
            },
            email: "Введите правильный email",
        }
    });

    $("#profilePass").validate({
        errorElement: 'span',
        errorClass: 'help-block',
        highlight: function (element, errorClass) {
            $(element).parent().parent().addClass('error');
        }, unhighlight: function (element, errorClass) {
            $(element).parent().parent().removeClass('error');
        },
        rules: {
            password: {
                required: true,
                minlength: 5
            },
            password_confirm: {
                equalTo: "#password"
            },
        },
        messages: {
            password: {
                required: "Введите пароль",
                minlength: "Пароль должен состоять минимум из 5 символов"
            },
            confirm_password: {
                equalTo: "Пароли не совпадают"
            },
        }
    });

    $("#registerRemember").validate({
        errorElement: 'div',
        errorClass: 'alert-error',
        highlight: function (element, errorClass) {
            $(element).parent().parent().addClass('error');
        }, unhighlight: function (element, errorClass) {
            $(element).parent().parent().removeClass('error');
        },
        rules: {
            rem_email: {
                required: true,
                email: true
            },
        },
        messages: {
            rem_email: {
                required: "Введите email",
                email: "Ошибка в email"
            },
        }
    });

    // propose username by combining first- and lastname
    $("#username").focus(function () {
        var firstname = $("#firstname").val();
        var lastname = $("#lastname").val();
        if (firstname && lastname && !this.value) {
            this.value = firstname + "." + lastname;
        }
    });

    //code to hide topic selection, disable for demo
    var newsletter = $("#newsletter");
    // newsletter topics are optional, hide at first
    var inital = newsletter.is(":checked");
    var topics = $("#newsletter_topics")[inital ? "removeClass" : "addClass"]("gray");
    var topicInputs = topics.find("input").attr("disabled", !inital);
    // show when newsletter is checked
    newsletter.click(function () {
        topics[this.checked ? "removeClass" : "addClass"]("gray");
        topicInputs.attr("disabled", !this.checked);
    });
});

function feedback() {

}
